import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cuitInput", "searchButton", "result"]
  static values = {
    patientId: Number,
    initialCuit: String,
    initialOrder: String
  }

  connect() {
    // Si hay una orden inicial y el paciente tiene CUIT, buscar automáticamente
    if (this.initialOrderValue && this.initialCuitValue) {
      setTimeout(() => {
        this.search()
      }, 500) // Dar tiempo a que se cargue el formulario
    }
  }

  handleKeypress(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.search()
    }
  }

  async search() {
    const cuit = this.cuitInputTarget.value.trim()

    if (!cuit) {
      this.showError("Por favor ingrese un CUIT")
      return
    }

    // Validar formato básico de CUIT (XX-XXXXXXXX-X)
    const cuitRegex = /^\d{2}-\d{8}-\d{1}$/
    if (!cuitRegex.test(cuit)) {
      this.showError("Formato de CUIT inválido. Use el formato: XX-XXXXXXXX-X")
      return
    }

    // Deshabilitar botón mientras busca
    this.searchButtonTarget.disabled = true
    this.searchButtonTarget.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Buscando...'
    this.resultTarget.style.display = "none"

    try {
      const response = await fetch(`/patients/${this.patientIdValue}/invoices_and_payments/search_colppy_client?cuit=${encodeURIComponent(cuit)}`, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (data.success) {
        this.showSuccess(data.client)
        // Actualizar el mensaje de estado
        this.updateStatusMessage(data.client.id, true)
      } else {
        this.showError(data.error || "Cliente no encontrado en Colppy")
        this.updateStatusMessage(null, false)
      }
    } catch (error) {
      console.error("Error buscando cliente en Colppy:", error)
      this.showError("Error al buscar cliente en Colppy. Por favor intente nuevamente.")
      this.updateStatusMessage(null, false)
    } finally {
      // Rehabilitar botón
      this.searchButtonTarget.disabled = false
      this.searchButtonTarget.innerHTML = '<i class="fas fa-search"></i> Buscar'
    }
  }

  showSuccess(client) {
    this.resultTarget.innerHTML = `
      <div class="alert alert-success">
        <i class="fas fa-check-circle"></i> <strong>Cliente encontrado en Colppy</strong><br>
        <small>
          ID: ${client.id}<br>
          Razón Social: ${client.razon_social || client.nombre_fantasia}<br>
          CUIT: ${client.cuit}<br>
          Condición IVA: ${client.id_condicion_iva || "N/A"} (${client.porcentaje_iva || "N/A"}%)
        </small>
      </div>
    `
    this.resultTarget.style.display = "block"
  }

  showError(message) {
    this.resultTarget.innerHTML = `
      <div class="alert alert-danger">
        <i class="fas fa-exclamation-circle"></i> ${message}
      </div>
    `
    this.resultTarget.style.display = "block"
  }

  updateStatusMessage(colppyClientId, found) {
    const statusMessage = document.getElementById("colppy-status-message")
    if (!statusMessage) return

    if (found && colppyClientId) {
      statusMessage.innerHTML = `<i class="fas fa-check-circle text-success"></i> Cliente encontrado en Colppy (ID: ${colppyClientId})`
      statusMessage.className = "form-text text-muted"
    } else {
      const cuit = this.cuitInputTarget.value.trim()
      if (cuit) {
        statusMessage.innerHTML = `<i class="fas fa-exclamation-triangle text-warning"></i> Cliente con CUIT: ${cuit} - Se buscará en Colppy al facturar`
        statusMessage.className = "form-text text-muted"
      } else {
        statusMessage.innerHTML = `<i class="fas fa-exclamation-circle text-danger"></i> El paciente debe tener CUIT para facturar en Colppy`
        statusMessage.className = "form-text text-muted"
      }
    }
  }
}
